import React from "react";
import { TextField, Grid, } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import useHandleForm from "./useHandleForm";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {
  const {
    data,
    handleClose,
    rowsToUse,
    items,
    setParentFormValue,
    disabled,
  } = props;
  const dispatch = useDispatch();


  const create = (dataToSend) => {
    // Inserto en el array
    const newItems = [...items, { ...dataToSend, number: items.length }];
    setParentFormValue(newItems.map((item, index) => ({ ...item, number: index + 1 })), "potentialQuestions");
    handleClose();
  }

  const modify = (dataToSend) => {
    // Busco segun el número
    let itemsClone = [...items];
    let elementToChange = itemsClone.findIndex(el => el.number === dataToSend.number);
    if (elementToChange > -1) {
      itemsClone[elementToChange] = dataToSend;
      setParentFormValue(itemsClone.map((item, index) => ({ ...item, number: index + 1 })), "potentialQuestions");
    }
    handleClose();
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
  } = useHandleForm(data, create, modify, openValidationError, rowsToUse);

  const handleSubmit = () => {
    submit();
  }

  return (
    <>
      <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
        <Grid container item xs={12}>
          <Grid container item alignItems="center" xs={12} style={gridStyle}> {/* Pregunta */}
            <TextField
              disabled={disabled}
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("pollQuestion")}
              value={formData.question}
              onChange={(e) => setFormValue(e.target.value, "question")}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ ...gridStyle, marginBottom: 70 }}> {/* Descripción */}
            <TextFieldMultiline
              disable={disabled}
              required
              fullWidth
              label={getLocalizedString("behaviorDescription")}
              rows={5}
              margin={"none"}
              value={formData.description}
              onChange={(e) => setFormValue(e.target.value, "description")}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={6} style={gridStyle}> {/* Sección */}
            <TextField
              fullWidth
              margin={"none"}
              label={getLocalizedString("section")}
              value={formData.section}
              onChange={(e) => setFormValue(e.target.value, "section")}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          {
            !disabled &&
            <Grid container item xs={12} justify={"flex-end"} alignItems="center" >
              <ButtonDialogAction isAccept onClick={handleSubmit} text={getLocalizedString("save")} />
            </Grid>
          }
        </Grid>
      </Grid>
    </>
  );
}

export default Form;
